/**
 * Ski Exchange - binding bundles, clickable binding names
 * Peachy Digital Media, 17/08/2026
 *
 * Andy's ask (14/08): the binding names in the picker should link through to
 * each binding's own product page. The picker itself is rendered by
 * bb-module.js, which builds the option list from bb-bindings.json. This
 * companion adds the links WITHOUT touching that safety-critical file: it reads
 * the same dataset, maps each variant id to its product handle, and wraps the
 * rendered name in an anchor. It re-applies after every re-render, and never
 * links the "No binding" row.
 *
 * The link opens in a new tab so the customer keeps their ski page, their
 * length choice and their binding selection.
 */

/* global window, document, fetch, MutationObserver */

(function () {
  'use strict';

  var root = document.getElementById('bb-module');
  if (!root) return;

  var options = document.getElementById('bb-options');
  if (!options) return;

  // The ski-data script carries the same dataset URL the module uses.
  var settings = {};
  try {
    settings = (JSON.parse(document.getElementById('bb-ski-data').textContent) || {}).settings || {};
  } catch (e) {
    return;
  }
  if (!settings.bindings_url) return;

  var variantToHandle = null; // built once the dataset is in

  // A light style so the names read as links without shouting.
  var style = document.createElement('style');
  style.textContent =
    '.bb-option-name a{color:inherit;text-decoration:underline;text-underline-offset:2px;}' +
    '.bb-option-name a:hover{text-decoration:none;}';
  document.head.appendChild(style);

  var observer = new MutationObserver(function () { wrapAll(); });

  function wrapOne(label) {
    if (!variantToHandle) return;
    var value = label.getAttribute('data-value');
    if (!value || value === 'none') return;
    var nameEl = label.querySelector('.bb-option-name');
    if (!nameEl || nameEl.querySelector('a')) return; // already linked
    var handle = variantToHandle[value];
    if (!handle) return;
    var a = document.createElement('a');
    a.href = '/products/' + handle;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = nameEl.textContent;
    // Viewing the product should not also toggle the radio selection.
    a.addEventListener('click', function (e) { e.stopPropagation(); });
    nameEl.textContent = '';
    nameEl.appendChild(a);
  }

  function wrapAll() {
    // Disconnect while we mutate, so our own DOM changes do not re-trigger us.
    observer.disconnect();
    var labels = options.querySelectorAll('.bb-option');
    for (var i = 0; i < labels.length; i++) wrapOne(labels[i]);
    observer.observe(options, { childList: true, subtree: true });
  }

  // Watch for the module's first render and every re-render (width, colour and
  // profile changes all rebuild the list and drop the anchors).
  observer.observe(options, { childList: true, subtree: true });

  fetch(settings.bindings_url)
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !data.bindings) return;
      variantToHandle = {};
      data.bindings.forEach(function (b) {
        if (!b.handle) return;
        (b.variants || []).forEach(function (v) {
          variantToHandle[String(v.id)] = b.handle;
        });
      });
      wrapAll();
    })
    .catch(function () { /* names simply stay as plain text */ });
})();
